(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name commons.controller:AssignPairingModalCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('AssignPairingModalCtrl', AssignPairingModalCtrl);

    function AssignPairingModalCtrl($timeout, CrewingHelper, MessageService, modalParams, $uibModalInstance, EventManagerService, RemoteService, PopupManager) {
        var vm = this;

        vm.model = {
            patternData: null,
            selectedPattern: null,
            isRequest: false,
            isShowPortalVisible:false,
            isShowPortalEnabled:false,
            isShowPortal:false,
            isCallFromDayOff: false,
            isObsFlight: false,
            isHideinCrewPortal: false,
            showNoRecord: false,
            patternTypes : null,
            pairingBases : null,
            searchByPairingBase : '',
            setDefaultBase : false,
            crewScheduleBlockId : null,
            isComplementFilled : false,
            isTargetHoursValid : true,
            isAirportRecencyOverridden : false,
            isRestrictedForAssigningIllegalDuties: false,
            isRestrictedOperation: false
        };

        vm.closeMe = function () {
            $uibModalInstance.close();
        };

        getPairings();
        getPairingBases();
        setDefaultBase();

        function getPairings() {
          console.log("getPairings :", modalParams.event);
            vm.model.crewScheduleBlockId = modalParams.crewScheduleBlockId;
            console.log("vm.model.crewScheduleBlockId :", vm.model.crewScheduleBlockId);
            vm.model.isShowPortal = angular.isUndefined(modalParams.showInCrewPortalParams)?false:modalParams.showInCrewPortalParams.value;
            vm.model.isShowPortalVisible = angular.isUndefined(modalParams.showInCrewPortalParams)?false:modalParams.showInCrewPortalParams.isVisible;
            vm.model.isShowPortalEnabled = angular.isUndefined(modalParams.showInCrewPortalParams)?false:modalParams.showInCrewPortalParams.isEnabled;

            if(!!modalParams.event){
              modalParams.event.callOutNotifyDateTime = modalParams.sbyCallOutDateTime;
            }


            CrewingHelper.searchPatternData(modalParams.crew.crewDTO.crewProfileId, modalParams.day.date, modalParams.event, null,
                function (data) {
                    vm.model.patternData = data.patternDTOs;
                    vm.model.targetHoursTolerance = data.targetHoursTolerance;
                    vm.model.crewTypesForTargetHrVal = data.crewTypesForTargetHrVal.split(",");
                    vm.model.patternTypes = getPatternTypes(vm.model.patternData);
                    vm.model.showNoRecord = vm.model.patternData.length == 0;
                },
                function (msg) {
                    MessageService.error(msg);
                }
            )
        }

        function getCrewBaseAssignment() {
            var request = createCrewBaseAssignmentRequest(modalParams.crew.crewDTO.crewProfileId, modalParams.day.date);

            RemoteService.crewBaseAssignmentByDate(request).then(
                function (data) {
                	if(vm.model.setDefaultBase){
                		vm.model.searchByPairingBase = data.crewBaseAssignmentAdaptDTO.base;
                	}
                },
                function (msg) {
                    MessageService.error(msg);
                }
            );
        }

        function setDefaultBase(){
            RemoteService.isSetDefaultBase().then(
                function (response) {
                    if(!!response && !!response.appParamValueDTO){
                    	vm.model.setDefaultBase = (("Y") == response.appParamValueDTO.paramValue) ? true : false;
                    } else {
                    	vm.model.setDefaultBase = false;
                    }
                    getCrewBaseAssignment();
                },
                function (msg) {
                    MessageService.error(msg);
                    getCrewBaseAssignment();
                }
            );
        }

        function getPairingBases(patternData){
            RemoteService.getBaseList().then(
                function (response) {
                    vm.model.pairingBases = prepareBaseList(response);
                },
                function (msg) {
                    MessageService.error(msg);
                }
            );
        }

        function prepareBaseList(data) {
            var result = [];
            var groups = _.groupBy(data.baseListDTOs,'airPortCode');
            angular.forEach(Object.keys(groups), function (tName) {
                result.push(tName)
            });
            return result
        }

        function createCrewBaseAssignmentRequest (crewProfileId, date) {
            return {
                crewProfileId: crewProfileId,
                localDate: date
            };
        };

        function getPatternTypes(patternData){
            var result = [];
            var groups = _.groupBy(patternData,'patternType');
            angular.forEach(Object.keys(groups), function (tName) {
                result.push({
                    name :tName.substr(0,1).toUpperCase()+tName.substr(1).toLowerCase()
                })
            });
            return result
        }

        function getPatternById(paringID) {
            CrewingHelper.getPatternById(paringID,
                function (data) {
                },
                function (msg) {
                    MessageService.error(msg)
                }
            );
        }

        function handleUpdateCrewRequirement(action) {
          console.log(action, vm.model.isComplementFilled);
          vm.model.isComplementFilled = true;
          console.log(vm.model.isComplementFilled);
          if (action === "save"){
            assignPairing();
          }
        }

        vm.onAssignPairingClick = function () {
          console.log("clicked ", vm.model.selectedPattern);
          var flyingMins = vm.model.selectedPattern.flyingMins;
          var MESSAGES=[];
          if(flyingMins > 0 && modalParams.showInCrewPortalParams.value && parseFloat(modalParams.targetDuration) > 0
              && vm.model.crewTypesForTargetHrVal.includes(modalParams.crew.crewType) && parseFloat(modalParams.flyingDuration) + (parseFloat(flyingMins)/60)> (parseFloat(modalParams.targetDuration) + parseFloat(vm.model.targetHoursTolerance))){
            var hourDifference = (parseFloat(modalParams.flyingDuration) +(parseFloat(flyingMins)/60) - (parseFloat(modalParams.targetDuration) + parseFloat(vm.model.targetHoursTolerance))).toString();
            var hours = Math.floor(hourDifference).toString();
            var minutes = Math.round((hourDifference - hours) * 60).toString();
            if(modalParams.showTargetHoursPopup){
                MESSAGES=["Crew Flying Hours exceeds Target Hours by "+ hours +" hours and "+ minutes +" minutes. Are you sure to continue?"];
                var details = {
                    title: 'Confirmation',
                    messages: MESSAGES
                };
                PopupManager.openModal('CONFIRM_DIALOG', details, confirmAssignPairing);
            }else{
                vm.model.isTargetHoursValid = false;
                continueAssignPairing();
            }

          }else{
            continueAssignPairing();
          }

//            if (!!vm.model.selectedPattern) {
//              if (CrewingHelper.isDistributionCheckApplicable(vm.model.selectedPattern.patternType)) {
//                CrewingHelper.checkDistributionWarnings(modalParams.crew.crewDTO.crewTypeMasterCode, vm.model.selectedPattern.patternId, modalParams.crew.crewDTO.crewProfileId, false, proceedAssignPairing, {});
//              } else {
//                proceedAssignPairing();
//              }
//            } else {
//                MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_PAIRING_WARNING);
//            }
        };

        function confirmAssignPairing(pass){
          if(pass=='YES') {
             vm.model.isTargetHoursValid = false;
             continueAssignPairing();
          }
        }
        function continueAssignPairing () {
            if (!!vm.model.selectedPattern) {
                var dutyStartLocation = vm.model.selectedPattern ? vm.model.selectedPattern.pairingBase : '';
                var crewProfileId = modalParams.crew.crewDTO ? modalParams.crew.crewDTO.crewProfileId : '';
                var dutyStartDate = vm.model.selectedPattern ? vm.model.selectedPattern.startDate + ' ' + vm.model.selectedPattern.startTime : '';
                var patternId = vm.model.selectedPattern ? vm.model.selectedPattern.patternId : 0;

                CrewingHelper.isViolatingDutyStartLocationtwithPreviousLocation(dutyStartLocation,
                    crewProfileId, dutyStartDate, patternId, function (updateResponse) {

                    if(!updateResponse.baseMatching) {
                        var details = {
                            title: 'Confirmation',
                            messages: [MessageService.MESSAGES.CREWING.PREVIOUS_DUTY_END_BASE_IS_DIFFERENT_FROM_THE_NEXT_DUTY_START_BASE]
                        };

                        PopupManager.openModal('CONFIRM_DIALOG', details, confirmtoProceed);

                        function confirmtoProceed(param) {
                            if (param === 'YES') {
                                checkAirportRecency();
                            }
                        }
                    } else {
                        checkAirportRecency();
                    }

                }, function (msg) {
                    MessageService.error(msg);
                });

            } else {
                MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_PAIRING_WARNING);
            }
        }
        function proccessAssignPairing () {

                  if (CrewingHelper.isDistributionCheckApplicable(vm.model.selectedPattern.patternType)) {
                    CrewingHelper.checkDistributionWarnings(modalParams.crew.crewDTO.crewTypeMasterCode, vm.model.selectedPattern.patternId, modalParams.crew.crewDTO.crewProfileId, false, proceedAssignPairing, {});
                  } else {
                    proceedAssignPairing();
                  }

        }

        function checkAirportRecency () {
                        var dutyStartLocation = vm.model.selectedPattern ? vm.model.selectedPattern.pairingBase : '';
                        var crewProfileId = modalParams.crew.crewDTO ? modalParams.crew.crewDTO.crewProfileId : '';
                        var dutyStartDate = vm.model.selectedPattern ? vm.model.selectedPattern.startDate + ' ' + vm.model.selectedPattern.startTime : '';
                        var patternId = vm.model.selectedPattern ? vm.model.selectedPattern.patternId : 0;

                        if (modalParams.crew.crewDTO.crewTypeMasterCode === "FC") {
                          CrewingHelper.isViolatingAirportRecency(crewProfileId, dutyStartDate, patternId, function (updateResponse) {
                            vm.model.isAirportRecencyOverridden = false;
                            console.log("date :", dutyStartDate);

                            if(!updateResponse.overridingAuthorized){
                              var details = {
                                title: 'Expired',
                                messages: ["Airport Recency Violated. ", "Airport(s): " + updateResponse.recencyExpiredAirports, "Sorry, You do not have authorization to override"]
                              };

                              PopupManager.openModal('WARNING', details, confirmtoProceed);

                              function confirmtoProceed(param) {
                                if (param === 'YES') {
                                }
                              }
                            }

                            else if(!updateResponse.recencyMet){
                              var details = {
                                title: 'Confirmation',
                                messages: [MessageService.MESSAGES.CREWING.AIRPORT_RECENCY_VIOLATED, "Airport(s): " + updateResponse.recencyExpiredAirports]
                              };

                              PopupManager.openModal('OVERRIDE_CONFIRM', details, confirmtoProceed);

                              function confirmtoProceed(param) {
                                if (param === 'YES') {
                                  vm.model.isAirportRecencyOverridden = true;
                                  proccessAssignPairing();
                                }
                              }
                            }
                            else if(updateResponse.recencyExpiringSoon) {
                              var details = {
                                title: 'Warning',
                                messages: ["Airport Recency Violating Soon For Airport(s) ", updateResponse.recencyExpiringSoonAirports]
                              };

                              PopupManager.openModal('WARNING', details, confirmtoProceed);

                              function confirmtoProceed(param) {
                                if (param === 'YES') {
                                  proccessAssignPairing();
                                }
                              }
                            }
                            else {
                              proccessAssignPairing();
                            }

                          }, function (msg) {
                            MessageService.error(msg);
                          });
                        }
                        else {
                          proccessAssignPairing();
                        }


        }

        vm.onSelectPairing = function (pattern) {
            vm.model.selectedPattern = pattern;
        };

        vm.onPairingOpen = function (pattern) {
            pattern.isOpen = !pattern.isOpen;
            if (pattern.isOpen && angular.isUndefined(pattern.moreDetail)) {
                CrewingHelper.getPatternById(pattern.patternId,
                    function (data) {
                        pattern.moreDetail = data;
                    },
                    function (msg) {
                        MessageService.error(msg);
                    }
                )
            }
        };


        function validateAssignCrewCount(){
          var details = {
            title: 'Confirmation',
            messages: [MessageService.MESSAGES.CREWING.CREW_REQUIREMENT_EXCEEDS]
          };
          PopupManager.openModal('CONFIRM_DIALOG', details, confirmCrewRequirementExceeds);

          function confirmCrewRequirementExceeds(param) {
            if(param === 'YES'){
              assignPairing();
            }else {
              return false;
            }
          }

        }

        function proceedAssignPairing() {
          vm.model.isComplementFilled = false;
          if(!!vm.model.selectedPattern.assignedCrew && !!vm.model.selectedPattern.requiredCrew
            && vm.model.selectedPattern.assignedCrew >= vm.model.selectedPattern.requiredCrew){
            validateAssignCrewCount();
          }else{
            assignPairing();
          }
        }

        function assignPairing(){
            CrewingHelper.assignPattern(
                modalParams.crew.crewDTO.crewProfileId,
                vm.model.selectedPattern,
                vm.model.isRequest,
                vm.model.isCallFromDayOff,
                vm.model.isObsFlight,
                vm.model.isHideinCrewPortal,
                true,
                false,
                vm.model.isShowPortal,
                vm.model.crewScheduleBlockId,
                vm.model.isComplementFilled,
                vm.model.isTargetHoursValid,
                modalParams.sbyCallOutDateTime,
                vm.model.isAirportRecencyOverridden,
                null,
                null,
                null,
                function success(data) {
                    console.log(data);
                    console.log(vm.model.patternData);
                    console.log(vm.model.isComplementFilled);

                    if (data.crewComplementNeedChange === true && vm.model.isComplementFilled === false){
                      var newParams = {};
                      newParams.patternId =  vm.model.selectedPattern.patternId;

                      RemoteService.getCrewRequirementsByPairingId(vm.model.selectedPattern.patternId).then(
                        function (response) {
                          console.log(response);
                          newParams.requiredList = response;
                          PopupManager.openModal('VIEW_CONFIRM_PAIRING_MODAL', newParams, handleUpdateCrewRequirement);
                        },
                        function (msg) {
                          console.log("error : " , msg);
                          MessageService.error(msg);
                        }
                      );
                    }

                    if (vm.model.isComplementFilled === true || data.crewComplementNeedChange === false){
                      var modalData = {
                        regulationDetails: data,
                        crewProfileId: modalParams.crew.crewDTO.crewProfileId,
                        crewTypeMasterCode : modalParams.crew.crewDTO.crewTypeMasterCode,
                        pattern: vm.model.selectedPattern,
                        isRequest: vm.model.isRequest,
                        isCallFromDayOff: vm.model.isCallFromDayOff,
                        isObsFlight: vm.model.isObsFlight,
                        isHideinCrewPortal: vm.model.isHideinCrewPortal,
                        isShowCrewPortal: vm.model.isShowPortal,
                        crewScheduleBlockId :vm.model.crewScheduleBlockId,
                        isComplementFilled: vm.model.isComplementFilled,
                        isTargetHoursValid: vm.model.isTargetHoursValid,
                        isAirportRecencyOverridden: vm.model.isAirportRecencyOverridden,
                        isRestrictedForAssigningIllegalDuties: !! data.restrictedForAssigningIllegalDuties,
                        isRestrictedOperation: !! data.restrictedOperation
                      };
                      $uibModalInstance.close(modalData);
                    }

                },
                function fail(msg) {
                    MessageService.error(msg);
                },
                vm.model.isComplementFilled
            );

        }

    }
}());
